const grades = { 
  grade_b: 'Dropshipping Agen',
  grade_c: 'Dropshipping Non Agen'
}

export default (grade = '') => grades[grade]